import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import siteMessage from "@insite/client-framework/SiteMessage";
import Button from "@insite/mobius/Button";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Link from "@insite/mobius/Link";
import Typography from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import { css } from "styled-components";


interface responseInterface {
    dateImported?: string;
    filePathForErrorFix?: string;
    rowsImported?: number;
    rowsWithError?: number;
    totalCount?: number;
    uploadComplete?: string;
    isItemTrackingWorksheet?: boolean;
}

interface OwnProps {
    response: responseInterface;
}



export interface ItemTrackingSuccessMessageStyle {
    container?: GridContainerProps;
    gridItem?: GridItemProps;
    wrapper?: InjectableCss;
    successHeaderWrapper?: InjectableCss;
    failureHeaderWrapper?: InjectableCss;
    bodyWrapper?: InjectableCss;
    pageTitle?: InjectableCss;
    headerTitle?: InjectableCss;
    text?: InjectableCss;
    downloadLinkTitle?: InjectableCss;
    downloadFile?: InjectableCss;
}

export const ItemTrackingSuccessMessageStyle: ItemTrackingSuccessMessageStyle = {
    container: {
        css: css`
        
        `},
    gridItem: {
        css: css`
        
        `},
    wrapper: {
        css: css`
            border: 1px solid lightgrey;
            width: 100%;
            border-bottom-right-radius: 8px;
            border-bottom-left-radius: 8px;

        `},
    successHeaderWrapper: {
        css: css`
            background: green;
            padding: 15px;
        
        `},
    failureHeaderWrapper: {
        css: css`
        background: red;
            padding: 15px;
        `},
    bodyWrapper: {
        css: css`
        padding: 25px 15px;
        min-height: 240px;

        `},
    pageTitle: {
        css: css`
            font-size: 20px;
            font-weight: 600;
            margin-bottom: 15px;
            margin-top: 20px;
        
        `},
    headerTitle: {
        css: css`
            font-weight: 600;
            color: #ffffff;
        `},
    text: {
        css: css`
            margin-bottom: 11px;
            
            `
    },
    downloadLinkTitle: {
        css: css`
                font-weight: 600;
                margin-top: 20px;
            `
    },
    downloadFile: {
        css: css`
            margin-top: 15px;
            padding: 10px 21px;
            background: #EDF4F8;
            border: 1px solid #0D70B7;
            border-radius: 22px;
            text-transform: uppercase;
             & :hover {
             span {
                 color: #ffffff;
    }
                }
            span {
                color: #0D70B7;
                & :hover {
                   color: #ffffff;
                }
            }
            `
    }
};
const styles = ItemTrackingSuccessMessageStyle;



const ItemTrackingSuccessMessage = (props: OwnProps) => {
    const { dateImported,
        filePathForErrorFix,
        rowsImported,
        rowsWithError = 0,
        totalCount,
        uploadComplete,
        isItemTrackingWorksheet } = props.response

    return (
        <GridContainer style={{ padding: "15px" }} >
            <GridItem width={12} style={{ flexDirection: "column" }}>
                <Typography as="h1" {...styles.pageTitle}>
                    {siteMessage("Item Tracking Upload:")}
                </Typography>
                <StyledWrapper {...styles.wrapper}>
                    <StyledWrapper {...(rowsImported && !rowsWithError ? { ...styles.successHeaderWrapper } : { ...styles.failureHeaderWrapper })}>
                        <Typography {...styles.headerTitle}>
                            {rowsImported && !rowsWithError ? siteMessage("Successful") : siteMessage("Failed")}
                        </Typography>
                    </StyledWrapper>

                    <StyledWrapper {...styles.bodyWrapper}>
                        {uploadComplete && <Typography as="p" {...styles.text}>
                            {siteMessage(uploadComplete)}
                        </Typography>
                        }
                        {isItemTrackingWorksheet && <>
                            <Typography as="p" {...styles.text}>
                                {siteMessage("Total rows in file:")} {totalCount}
                            </Typography>
                            <Typography as="p" {...styles.text}>
                                {siteMessage("Total rows imported:")} {rowsImported}
                            </Typography>

                            {rowsWithError > 0 && <Typography as="p" {...styles.text}>
                                {siteMessage("Rows with errors found:")} {rowsWithError}
                            </Typography>
                            }
                        </>}

                        {dateImported && <Typography as="p" {...styles.text}>
                            {siteMessage("Date imported:")} {dateImported}
                        </Typography>
                        }

                        {filePathForErrorFix && <>
                            <Typography as="p" {...styles.downloadLinkTitle}>
                                {siteMessage("Download the file below to review and fix errors.")}
                            </Typography>
                            <Button onClick={(e) => {
                                e.preventDefault();

                                const link = document.createElement("a");
                                link.href = filePathForErrorFix;
                                link.setAttribute("download", "");
                                document.body.appendChild(link);
                                link.click();
                                document.body.removeChild(link);
                            }} {...styles.downloadFile}>
                                {siteMessage("Download File with errors")}
                            </Button>
                        </>
                        }

                    </StyledWrapper>
                </StyledWrapper>

            </GridItem>
        </GridContainer>
    );
};


export default ItemTrackingSuccessMessage;
